import {
  Home,
  Settings,
  Zap,
  GitBranch,
  User,
  Wallet,
  Gift,
  Gem,
} from "lucide-react";
import { PAGE_NAME } from "../types";

export const DESKTOP_NAV_LINKS = [
  { href: PAGE_NAME.HOME, name: "Home", icon: Home },
  { href: PAGE_NAME.STAKE, name: "Stake", icon: GitBranch },
  { href: PAGE_NAME.TREASURE_VAULT, name: "Vault", icon: Gem },
  { href: PAGE_NAME.WALLET, name: "Wallet", icon: Wallet },
  { href: PAGE_NAME.REWARDS, name: "Rewards", icon: Gift },
  { href: PAGE_NAME.PROFILE, name: "Profile", icon: User },
  { href: PAGE_NAME.SETTINGS, name: "Settings", icon: Settings },
];
export const MOBILE_DRAWER_LINKS = [];

export const MOBILE_NAV_LINKS = [
  { href: PAGE_NAME.HOME, name: "Home", icon: Home },
  { href: PAGE_NAME.STAKE, name: "Stake", icon: GitBranch },
  { href: PAGE_NAME.TREASURE_VAULT, name: "Vault", icon: Gem },
  { href: PAGE_NAME.WALLET, name: "Wallet", icon: Wallet },
  { href: PAGE_NAME.REWARDS, name: "Rewards", icon: Gift },
];

export const EXCLUDED_ROUTES = [
  "/",
  PAGE_NAME.ONBOARDING_LOCAL,
  PAGE_NAME.LOGIN,
  PAGE_NAME.ONBOARDING_SIGN,
  PAGE_NAME.ONBOARDING_SIGN_UP,
  PAGE_NAME.ONBOARDING_SIGN_UP_WITH_PI,
];
